<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <div v-if="!loading">
      <div class="edit-cont">
        <div class="edit-text">For editing your DoveMed profile, please visit your profile.</div>
        <!-- <div class="edit-text">Edit additional information on your DoveMed Non-For-Profit profile.</div> -->
        <a-button class="profile-btn" @click="GotoPhyProfile()">Visit Profile</a-button>
      </div>

      <div v-if="profileData['about'].length > 0" class="about-cont">
        <div class="header">About the organization</div>
        <div class="bio">{{ profileData["about"] }}</div>
      </div>

      <!-- <div class="pad" :style="{ 'margin-bottom': '80px' }">
        <DoctorAboutReview :refId="profileData.ext_ref_id" :IsOwnerView="true" />
      </div> -->

      <div class="pad" :style="{ 'margin-bottom': '80px' }">
        <DoctorAboutRecommend :refId="profileData.ext_ref_id" :IsOwnerView="true" />
      </div>

      <!-- <div v-for="(cardValue, cardKey, index) in cardKeys" :key="index"> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'about'">
        <div style="display: flex; justify-content: space-between">
          <p class="title">{{ cardKey | humanize }}</p>
        </div>
        <p v-if="!cardValue">{{ profileData[cardKey] }}</p>
        <p class="title">MISSION STATEMENT</p>
          <p v-if="profileData.mission_statement " >
             <i> "{{ profileData.mission_statement }}"</i>
        </p>
        <a-textarea
          v-model="profileData[cardKey]"
          :rows="4"
          v-if="cardValue"
          class="editable-textarea"
        />
        <button
          class="dovemed-button primary-border font-primary ml-4"
          v-if="cardValue"
          @click="save(cardKey)"
        >
          Save
        </button>
        <button
          class="dovemed-button primary-border font-primary ml-4"
          v-if="cardValue"
          @click="cancelEditable(cardKey)"
        >
          Cancel
        </button>
      </div> -->

      <!-- <div class="dovemed-card" v-if="cardKey === 'language_spoken'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div class="language">
          <div
            v-for="(language, index) in profileData[cardKey]"
            :key="index"
            class="mono-language"
          >
            <img :src="language.icon" />
            <p>{{ language.language }}</p>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'intrested_areas'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div class="language">
          <div
            v-for="(area, index) in profileData[cardKey]"
            :key="index"
            class="mono-language"
          >
            <img :src="area.icon" />
            <p>{{ area.name }}</p>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'conditions_treated'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div>
          <ul>
            <li v-for="(item, index) in profileData[cardKey]" :key="index">
              <a
                :style="item.link && { color: '#0e72ba !important' }"
                class="ml-2"
                target="_blank"
                :href="item.link"
                >{{ item.condition }}</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'procedures_performed'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div>
          <ul>
            <li v-for="(item, index) in profileData[cardKey]" :key="index">
              <a
                class="ml-2"
                :style="item.link && { color: '#0e72ba !important' }"
                target="_blank"
                :href="item.link"
                >{{ item.procedure }}</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'accepted_insurance'">
        <p class="title">
          {{ cardKey | humanize }} {{ profileData[cardKey] | total }}
        </p>
        <div>
          <ul>
            <li v-for="(item, index) in profileData[cardKey]" :key="index">
              {{ item.carrier }}
            </li>
          </ul>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'hospital_affiliations'">
        <p class="title">{{ cardKey | humanize }} {{ profileData | total }}</p>
        <div>
          <div v-for="(item, index) in profileData[cardKey]" :key="index">
            <div class="dovemed-card d-flex">
              <img class="mr-4" :src="item.picture" />
              <div>
                <p>{{ item.hospital_name }} ({{ item.hospital_type }})</p>
                <p>{{ item.phone_number }}</p>
                <p>{{ item.address }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'educational_qualifications'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div :header="itemKey" :key="ItemIndex">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <p v-if="nestItemValue">
                {{ nestItemKey | humanize(false) }}: {{ nestItemValue }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'board_certifications'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div :header="itemKey" :key="ItemIndex">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <p v-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'state_licensure'">
        <p class="title">{{ cardKey | humanize }} {{ profileData | total }}</p>
        <div>
          <div v-for="(item, index) in profileData[cardKey]" :key="index">
            <div class="dovemed-card">
              <p v-if="item.license_number">
                <b>License Number:</b> {{ item.license_number }}
              </p>
              <p><b>State:</b> {{ item.state }}</p>
              <p>
                <b>Status:</b>
                <span>{{ item.is_active ? "Active" : "Inactive" }}</span>
              </p>
              <p v-if="item.issue_date">
                <b>Affiliation Date:</b> <span>{{ item.issue_date }}</span>
              </p>
              <p v-if="item.expire_date">
                <b>Expiry Date:</b> <span>{{ item.expire_date }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'academic_affiliations'">
        <p class="title">{{ cardKey | humanize }} {{ profileData | total }}</p>
        <div>
          <div v-for="(item, index) in profileData[cardKey]" :key="index">
            <div class="dovemed-card">
              <p>
                <b>Name of Organization:</b> {{ item.name_of_organization }}
              </p>
              <p>
                <b>Affiliation:</b>
                <span>{{
                  item.currently_affiliated ? "Affiliated" : "Not Affiliated"
                }}</span>
              </p>
              <p v-if="item.from_date">
                <b>Affiliation Date:</b> <span>{{ item.from_date }}</span>
              </p>
              <p v-if="item.to_date">
                <b>Expiry Date:</b> <span>{{ item.to_date }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'medical_school'">
        <p class="title">{{ cardKey | humanize }} {{ profileData | total }}</p>
        <div>
          <div v-for="(item, index) in profileData[cardKey]" :key="index">
            <div v-if="item.university" class="dovemed-card">
              <p v-if="item.degrees"><b>Degree:</b> {{ item.degrees }}</p>
              <p v-if="item.year_of_completion">
                <b>{{ "year_of_completion" | humanize(false) }}:</b>
                {{ item.year_of_completion }}
              </p>
              <p v-if="item.academic_awards">
                <b>Academic Awards:</b> {{ item.academic_awards }}
              </p>
              <p v-if="item.university">
                <b>University:</b> {{ item.university.name }}
              </p>
              <p v-if="item.city"><b>City:</b> {{ item.city }}</p>
              <p v-if="item.state"><b>State:</b> {{ item.state }}</p>
              <p v-if="item.country"><b>Country:</b> {{ item.country.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'residency'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'chief_residency'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'other_education'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img
                v-if="nestItemKey === 'imagge'"
                :src="nestItemValue"
                alt=""
              />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'internship'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="dovemed-card" v-if="cardKey === 'fellowship'">
        <p class="title">{{ cardKey | humanize }}</p>
        <div
          v-for="(itemValue, itemKey, ItemIndex) in profileData[cardKey]"
          :key="ItemIndex"
        >
          <div class="dovemed-card">
            <div
              v-for="(nestItemValue, nestItemKey, nestItemIndex) in itemValue"
              :key="nestItemIndex"
            >
              <img v-if="nestItemKey === 'image'" :src="nestItemValue" alt="" />
              <p v-else-if="typeof nestItemValue === 'string'">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue }}
              </p>
              <p v-else-if="nestItemValue && nestItemValue.name">
                <b>{{ nestItemKey | humanize(false) }}</b
                >: {{ nestItemValue.name }}
                <img
                  :width="25"
                  v-if="nestItemValue.icon"
                  :src="nestItemValue.icon"
                />
              </p>
            </div>
          </div>
        </div>
      </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import DoctorAboutRecommend from "./view/DoctorAboutRecommend.vue"
import DoctorAboutReview from "./view/DoctorAboutReview.vue"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "NFP_PROFILE",
  components: {
    DoctorAboutRecommend,
    DoctorAboutReview,
  },
  data() {
    return {
      cardKeys: null,
      profileData: null,
      toDeleteKeys: [
        "id",
        "created_at",
        "updated_at",
        "is_deleted",
        "user",
        "is_verified",
        "npi_number",
        "state_licence",
        "licence_number",
        "display_name",
        "rec_description",
        "rec_option",
        "rec_user",
        "rec_user_circle",
        "recommendations",
        "user_circle",
      ],
      // test: null
      status: false,
      loading: true,
    }
  },
  created() {
    console.warn("NFP_Profile.vue created")
    this.fetchData()
  },

  methods: {
    /**
     * Fetch user profile data
     */
    async fetchData() {
      this.loading = true
      const data = await UserRepository.getAbout(this.authUser.user, this.currentCircle.id)
      this.profileData = data.data.data ? data.data.data[0] : {}
      this.loading = false
      let profileDataCopy = { ...this.profileData }
      this.toDeleteKeys.forEach(key => {
        delete profileDataCopy[key]
      })
      // const keys = Object.keys(profileDataCopy)
      const keys = Object.keys(profileDataCopy)
      this.cardKeys = this.makeKeys(keys)
      this.status = true
    },

    makeKeys(cardKeys) {
      let editableKeys = {}
      for (var key in cardKeys) {
        if (cardKeys.hasOwnProperty(key)) {
          editableKeys[cardKeys[key]] = false
        }
      }
      return editableKeys
    },

    GotoPhyProfile() {
      window.open(`${process.env.SSO_BASE_URL}/ratings/nfp/${this.authUser.user.ext_ref_id}-${this.authUser.user.first_name}-${this.authUser.user.last_name.split(" ").join("-")}`, "_blank")
    },

    filters: {
      humanize: function (value, capitalize = true) {
        if (!value) return ""
        return capitalize
          ? value
              .toLowerCase()
              .split("_")
              .map(e => e.toUpperCase())
              .join(" ")
          : value
              .toLowerCase()
              .split("_")
              .map(e => e.charAt(0).toUpperCase() + e.substring(1))
              .join(" ")
      },

      total: function (value, ...options) {
        if (!value) return ""
        return Array.isArray(value) ? `(${value.length})` : ""
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.bio {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
  text-align: justify;
}

.header {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  width: 100%;
  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
}

.edit-text {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f !important;
  text-align: center;
}

.edit-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 16px;
  background: #f1f5f9;
  margin-bottom: 80px;
}

.pad {
  padding: 24px;

  @media screen and (max-width: 900px) {
    padding: 0px;
  }
}

.about-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  margin-bottom: 80px;

  @media screen and (max-width: 900px) {
    padding: 0px;
  }
}

.profile-btn {
  padding: 8px 16px;
  background: #062b54;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

.dovemed-icon-button {
  border-radius: 50%;
  font-size: 15px;
  border: none;
  width: 20px;
  height: 20px;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  img {
    border-radius: 0.5em;
    max-width: 150px;
    max-height: 150px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  ul {
    list-style: none;
    /* Remove default bullets */
  }

  ul li::before {
    content: "\2022";
    font-weight: bold;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: -1em;
  }

  .language {
    margin-left: 20px;
  }

  .mono-language {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin: 1em 0;

    img {
      width: 2em;
    }

    p {
      margin-left: 1em;
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/NFP_Profile.vue